export default "__VITE_ASSET__ArQ75RBx__"